import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef} from '@angular/core';
import { 
    IonSpinner
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvDateService } from '@marv/services';
import { MarvMessageComponent } from '@marv/components';
import { OperationItem, OperationItemComponent  } from '@app/components';
import { OperationService } from '@app/services';

@Component({
    selector: 'app-operation-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonSpinner, TranslatePipe, forwardRef(() => MarvMessageComponent), forwardRef(() => OperationItemComponent)
    ]
})
export class OperationListComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];
    @Input({alias : 'displayRemainingDays', required : false}) displayRemainingDays: boolean = true;
    @Input({alias : 'displayQuota', required : false}) displayQuota: boolean = true;
    @Input({alias : 'displayBtnAddIntervention', required : false}) displayBtnAddIntervention: boolean = false;
    @Input({alias : 'disabledBtnAddIntervention', required : false}) disabledBtnAddIntervention: boolean = false;
    @Input({alias : 'activePlanningOnly', required : false}) activePlanningOnly: boolean = false;
    @Output() onSelectOperation = new EventEmitter<OperationItem>();
    @Output() onAddIntervention = new EventEmitter<OperationItem>();

    isFetching: boolean = false;  
    operationsItems: Array<OperationItem> = [];  
    operationsItemsDisplayed: Array<OperationItem> = [];  

    constructor(
        
    ) { }

    async ngOnInit() {
        this.isFetching = true;
        let operationsItems: Array<OperationItem> = [];
        let operations = OperationService.Operations;  
        if(operations){            
            let today = MarvDateService.GetToday();
            for(let o of operations){      
                let planningOpenFrom = (o.planningOpenFrom ? o.planningOpenFrom : today);
                let planningOpenUntil = (o.planningOpenUntil ? o.planningOpenUntil : today);
                if(o.type === 'loga' && o.currentlyActive
                    && (!this.activePlanningOnly || (planningOpenFrom <= today && today <= planningOpenUntil))
                    ){
                    operationsItems.push(OperationItem.FromOperationCard(o));
                }
            }
        }  
        this.operationsItems = operationsItems;
        this.getOperationsItems();
        this.isFetching = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            this.getOperationsItems();
        }
    }
    
    getOperationsItems(){        
        this.operationsItemsDisplayed = this.operationsItems.filter(o => (this.typesMissions.length === 0 || this.typesMissions.indexOf(o.type) !== -1));         
    }
    
    selectOperation(operationItem: OperationItem){
        this.onSelectOperation.emit(operationItem);
    }
    
    addIntervention(operationItem: OperationItem){
        this.onAddIntervention.emit(operationItem);
    }
}
